import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../api/ApiRoutes";

export async function fetchProcessedTransactions({
  start_date,
  end_date,
  page_size,
  page,
  last_evaluated_key,
  total_count,
  subregion,
  method,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const payload = {
    page_size,
    page,
    start_date,
    end_date,
    last_evaluated_key,
    ...(subregion && { subregion }),
    ...(method && { method }),
  };

  if (page === 1) {
    payload.last_evaluated_key = null;
  }

  if (typeof total_count === "number") {
    payload.total_count = total_count;
  }

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.GET_PROCESSED_TRANSACTIONS,
    payload
  );

  return (
    response?.data?.data ?? {
      transactions: [],
      pagination: { page, page_size, total_results: 0 },
    }
  );
}

export const useGetProcessedTransactions = (
  start_date,
  end_date,
  page_size,
  page,
  last_evaluated_key,
  total_count,
  subregion = null,
  method = null
) => {
  return useQuery({
    queryKey: [
      "GET_PROCESSED_TRANSACTIONS",
      start_date,
      end_date,
      page_size,
      page,
      subregion,
      method,
    ],
    queryFn: () =>
      fetchProcessedTransactions({
        start_date,
        end_date,
        page_size,
        page,
        last_evaluated_key,
        total_count,
        subregion,
        method,
      }),
    keepPreviousData: true,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
